import { register } from '../../../../Javascript/Sysmex/Utils'

const SubscriptionCenter = el => {
  const dynamicsFrame = document.querySelector('.frame-type-content_msdynamics') // contact form container

  /* eslint-disable */
  el.addEventListener('click', (e) => {
    // check if clicked element inside component is button and is type 'submit'
    if (e.target instanceof HTMLButtonElement && e.target.type === 'submit') {
      // wait one second and check if success message exists
      setTimeout(() => {
        if (el.querySelector('[data-submissionresponse="success"]')) {
          // if dataLayer exists push event
          if (window.dataLayer) {
            if (dynamicsFrame) {
              window.dataLayer.push({
                event: 'contact_form_submit',
                formType: 'dynamics'
              })
            }
          }
        }
      }, 1000)
    }
  })
}

register('SubscriptionCenter', SubscriptionCenter)
